import Admin from 'hive-admin';

import {
  ADMIN as FILTERS_ADMIN,
  SELLER_MERCHANT as FILTERS_SELLER_MERCHANT,
  SELLER_REFERRAL as FILTERS_SELLER_REFERRAL,
} from './filters';

import {
  ADMIN as COLUMNS_ADMIN,
  SELLER_MERCHANT as COLUMNS_SELLER_MERCHANT,
  SELLER_REFERRAL as COLUMNS_SELLER_REFERRAL,
} from './columns';

import {
  ADMIN as FIELDS_ADMIN,
  SELLER as FIELDS_SELLER,
} from './fields';

import tests from '../../helpers/tests';

const {
  viewerIsSellerReferral,
} = tests;

export default [
  ['ADMIN', {
    path: '/referrals',
  }],
  ['SELLER_MERCHANT', {
    path: '/store/referrals',
    archiveLoadUrl: '/referrals',
  }],
  ['SELLER_REFERRAL', {
    path: '/store/partners/referrals',
  }],
].reduce(
  (pages, [specificRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS,
    ] = (
        specificRole === 'ADMIN'
      ? [COLUMNS_ADMIN, FILTERS_ADMIN, FIELDS_ADMIN]
      : specificRole === 'SELLER_MERCHANT'
      ? [COLUMNS_SELLER_MERCHANT, FILTERS_SELLER_MERCHANT, FIELDS_SELLER]
      : specificRole === 'SELLER_REFERRAL'
      ? [COLUMNS_SELLER_REFERRAL, FILTERS_SELLER_REFERRAL, FIELDS_SELLER]
      : []
    );
    const redirect = [
      ['redirect.unauthorized'],
      [
        'redirect.viewerSpecificRoleIsNot',
        specificRole,
        currentSpecificRole => (
            currentSpecificRole === 'ADMIN'
          ? '/referrals'
          : currentSpecificRole === 'SELLER_MERCHANT'
          ? '/store/referrals'
          : currentSpecificRole === 'SELLER_REFERRAL'
          ? '/store/partners/referrals'
          : null
        ),
      ],
    ];
    const hidden = [
      ['condition.viewerSpecificRoleIsNot', specificRole],
    ];
    switch (specificRole) {
      case 'ADMIN':
      case 'SELLER_MERCHANT':
        pages.push(...Admin.compileFromLibrary(['GroupResource', {
          title: 'Referrals',
          // icon: 'team',
          archiveConfig: {
            title: 'Referrals',
            label: 'Referrals',
            // icon: 'team',
            hidden,
            createButtonPath: `${config.path}/create`,
          },
          singleLoadUrl: '/referrals/:id/',
          singleConfig: {
            hidden: true,
            alias: config.path,
            backButtonPaths: [config.path],
          },
          singleEditConfig: {
            actions: [
              ['ActionSaveAndReload', { skip: [viewerIsSellerReferral] }],
              // ['ActionDelete'],
            ],
          },
          redirect,
          columns: COLUMNS,
          filters: FILTERS,
          fields: FIELDS,
          ...config,
        }]).pages);
      break;
      case 'SELLER_REFERRAL':
        pages.push(['PageArchiveTable', {
          title: 'Referrals',
          icon: 'team',
          path: '/store/partners/referrals',
          exact: true,
          loadUrl: '/referrals',
          columns: COLUMNS,
          filters: FILTERS,
          redirect,
          hidden,
          createButtonSupported: false,
          loadExtractData: response => (
            response
            ? { count: response.data.count, data: response.data.data }
            : { count: 0, data: [] }
          ),
        }]);
        pages.push(['PageSingle', {
          title: 'Referral',
          activity: 'edit',
          path: `${config.path}/:id`,
          alias: config.path,
          loadUrl: '/referrals/:id',
          actions: [],
          backButtonPaths: [config.path],
          fields: FIELDS,
          redirect,
          hidden: true,
        }]);
        break;
      default:
    }
    return pages;
  },
  [],
);
